import UploadFile from "@mui/icons-material/UploadFile";
import { Button, ButtonProps } from "@mui/material";
import { ShippingDocumentKind } from "generated-graphql/graphql";
import { useQueueManifestDocumentExtraction } from "hooks/useQueueManifestDocumentExtraction";
import { useState } from "react";

import { ShippingRecordUploadFlow } from "./ShippingRecordUploadFlow";

type AddManifestButtonProps = {
  tenantId: string;
  facilityId?: string;
  /** MUI Button size — defaults to "medium" */
  size?: ButtonProps["size"];
  /** Disables the button and suppresses the upload flow (e.g. archived facility). */
  disabled?: boolean;
  /**
   * Called once the review is applied, which fires after the last document's
   * save succeeds, not when the dialog is merely closed. A list host uses it
   * to refetch.
   */
  onSaved?: () => void;
};

export function AddManifestButton({
  tenantId,
  facilityId,
  size,
  disabled,
  onSaved,
}: AddManifestButtonProps) {
  const { canQueueManifestExtraction } = useQueueManifestDocumentExtraction();
  const [open, setOpen] = useState(false);

  if (!canQueueManifestExtraction) return null;

  return (
    <>
      <Button
        variant="contained"
        size={size}
        startIcon={<UploadFile />}
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        Add Manifest
      </Button>
      <ShippingRecordUploadFlow
        documentKind={ShippingDocumentKind.Manifest}
        tenantId={tenantId}
        facilityId={facilityId}
        open={open}
        onClose={() => setOpen(false)}
        onSaved={onSaved}
      />
    </>
  );
}
